import PunchAttendanceStatus from "../../features/punchAttendance/components/status";

const MarkAttendanceStatusContainer = () => {
  return (
    <div className="page-body p-0">
      <PunchAttendanceStatus />
    </div>
  );
};

export default MarkAttendanceStatusContainer;
